import { Stack } from '@mui/material';
import { DateTimeInput, SelectInput, TextInput } from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { useConfigurationContext } from '../root/ConfigurationContext';
import { formatNoteDate, getCurrentDate } from './utils';
import { Status } from '../misc/Status';

export const NoteInputs = ({
    showStatus,
    edition,
}: {
    showStatus?: boolean;
    edition?: boolean;
}) => {
    const { noteStatuses } = useConfigurationContext();
    const { setValue } = useFormContext();
    return (
        <>
            <TextInput
                source="text"
                label={edition ? 'Edit note' : 'Add a note'}
                variant="filled"
                size="small"
                multiline
                minRows={3}
                helperText={false}
                onFocus={() => {
                    if (!edition) {
                        setValue('date', getCurrentDate());
                    }
                }}
            />
            {showStatus && (
                <Stack direction="row" spacing={2} mt={1}>
                    <SelectInput
                        source="status"
                        choices={noteStatuses}
                        optionValue="value"
                        optionText={optionRenderer}
                        isRequired
                        defaultValue={'warm'}
                        helperText={false}
                    />
                    <DateTimeInput
                        source="date"
                        label="Date"
                        helperText={false}
                        parse={formatNoteDate}
                    />
                </Stack>
            )}
        </>
    );
};

const optionRenderer = (choice: any) => (
    <div>
        {choice.label} <Status status={choice.value} />
    </div>
);
